import { AnalyticsStore } from './analytics.store';
import { VideoStore } from './video.store';
import { ControlsStrategyFactory } from './controls/controls-strategy-factory';
import { ConfigStore } from './config.store';
import { AdContainerStore } from './ad-container.store';
import { AdContainerAdapterFactory } from '../../infrastructure/ad-container-adapter.factory';
import { DebugLog } from '../debug-log';
import { AdContextStore } from './ad-context.store';

interface IHandlerConstructor {
  new (rootStoreInstance: RootStore): any;
}

export class RootStore {
  static _instance?: RootStore;

  // Stores
  configStore!: ConfigStore;
  adContainerStore!: AdContainerStore;
  videoStore!: VideoStore;
  analyticsStore!: AnalyticsStore;
  _controlsStrategyFactory!: ControlsStrategyFactory;
  adContextStore!: AdContextStore;

  msAdsOptions!: FormatOptions;

  static getInstance(): RootStore {
    if (!this._instance) {
      this._instance = new RootStore();
    }
    return this._instance;
  }

  // TODO [SPY-15516-mraid-isReady]: See if msAdsOptions should be set in the configStore or in a dedicated place
  initStore(
    config: FormatConfig,
    context: AdContext,
    msAdsOptions: FormatOptions
  ): RootStore {
    DebugLog.log('RootStore.initStore called', {
      config,
      context,
      msAdsOptions
    });

    this.configStore = ConfigStore.createInstance(config);
    this.adContextStore = AdContextStore.createInstance(context);

    this.msAdsOptions = msAdsOptions;

    this.adContainerStore = new AdContainerStore(
      AdContainerAdapterFactory.create(msAdsOptions, this.configStore),
      this.msAdsOptions
    );

    this.videoStore = new VideoStore(
      this.configStore,
      context,
      this.adContainerStore
    );

    this.analyticsStore = new AnalyticsStore(this.videoStore);
    this._controlsStrategyFactory = new ControlsStrategyFactory(
      this.videoStore,
      this.configStore,
      context
    );

    DebugLog.log('RootStore.initStore completed');
    return this;
  }

  initHandlers(...handlers: IHandlerConstructor[]): void {
    handlers.forEach(handler => new handler(this));
  }

  get controlsStore() {
    return this._controlsStrategyFactory?.strategy.value;
  }
}
